import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { shouldRouteToVendorPortal } from '../../utils/authRoles';

const VendorPortalBoundary = ({ children, fallback = null }) => {
  const location = useLocation();
  const {
    user,
    profile,
    isAuthenticated,
    loading,
  } = useSelector((state) => state.auth);

  // Never render a role-specific workspace until the trusted Rails profile is
  // available. Supabase metadata is intentionally insufficient for deciding
  // whether an authenticated account is a buyer or an approved supplier.
  if (loading || (isAuthenticated && !profile?.rails_profile)) {
    return fallback;
  }

  if (shouldRouteToVendorPortal(user, profile, location.pathname)) {
    return <Navigate to="/vendor/dashboard" replace />;
  }

  return children;
};

export default VendorPortalBoundary;
